import { AppState } from '../reducers/app.state';

export const selectUserStateRedirectUrl = (state: AppState) => state.userData.redirectUrl;
export const selectUserStateUser = (state: AppState) => state.userData.user;
export const selectUserStateUserRole = (state: AppState) => state.userData.user?.role;
export const selectUserStatePatient = (state: AppState) => state.userData.patient;
export const selectUserIsProfessional = (state: AppState) => !!state.userData.user?.professional || state.userData.user?.isHealthcareWorker;
export const selectPatientSSIN = (state: AppState) => state.userData.patient?.ssin;
export const selectMandateType = (state: AppState) => state.userData.mandateType;
export const selectUserIsHealthcareWorker = (state: AppState) => state.userData.user?.isHealthcareWorker;
export const selectUserIsNotProfessional = (state: AppState) => !selectUserIsProfessional(state);
